/** @format */

import React, { useState } from "react";
import { useHistory } from "react-router";
import _ from "lodash";
import clsx from "clsx";
import { IconButton, Checkbox } from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { NeedIcon, NeedListItem, AcuityNeedItem, PriorityBadge } from "./TransferIcons";
import CompassIcon from "./helpers/CompassIcon";
import { getOriginLocationString, getDestinationLocationString,getTimeFromDate, getTimeFromDatebyZone } from "../../common/helpers";
import { makeStyles } from "@material-ui/core/styles";
import { checkuserpermissiontransfer } from "./conflictNotices/conflictNoticeHelper";
import api from "../../store/api";
import { IVirtualTrip, ITransfer } from "../../common/plannerTypes";
import { ServicedBy } from "./types/plannerTypes";
import { getData, getRoles, persistName, setData } from "./helpers/transferScheduleHelpers";
import { consts } from "../../common/consts";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
const Status = ({ rolesAndFeatures, setCurrentTransferId, setCurrentBookingId, setShowVehicleModal, assignToMeClick, transfer,setCurrentTripPlannerId,tripPlanner,vechiclecount }: any) => {
  const classes = useStyles();
  const { authStore } = useSelector((state: RootState) => state);
  let checkRolesForCustomer;
  let checkRolesForSma;
  if(tripPlanner.sharingRole === consts.Permissions.Primary)
  checkRolesForCustomer =  authStore.data?.role.split(",").some( p => p === consts.Permissions.Addtransfers); 
  if(tripPlanner.sharingRole === consts.Permissions.Secondary)
  checkRolesForCustomer =  authStore.data?.role.split(",").some( p => p === consts.Permissions.AddtransfersSecondary)
  if(tripPlanner.sharingRole === consts.Permissions.Primary)
  checkRolesForSma =  authStore.data?.role.split(",").some( p => p === consts.Permissions.SMAAddtransfers); 
  if(tripPlanner.sharingRole === consts.Permissions.Secondary)
  checkRolesForSma =  authStore.data?.role.split(",").some( p => p === consts.Permissions.SMAAddtransfersSecondary)
  if (transfer.status == 3) {
    return <>In Progress</>;
  } else if (transfer.status == 4) {
    return <>Complete</>;
  } else if (transfer.status == 6) {
    return <>Aborted</>;
  } else if (transfer.status == 7) {
    return <>Picking Up</>;
  } else if (transfer.status == 8) {
    return <>EnRoute To Destination</>;
  } else if (transfer.status == 9) {
    return <>Dropping Off</>;
  } else if (transfer.status == 10) {
    return <>Completed</>;
  } else if (transfer.status == 11) {
    return <>Cancelled</>;
  } else if (transfer.assignedToMe) {
    return <>Assigned To Me</>;
  } else if (transfer.assignedVehicle) {
    return <>Assigned to {transfer.assignedVehicle}</>;
  } else if (rolesAndFeatures.isAdmin) {
    return (
      <>
        Scheduled{" "}
        <span
          onClick={(e: any) => {
            e.stopPropagation();
            setCurrentTransferId(transfer.transferId);
            setCurrentBookingId(transfer.bookingId);
            setShowVehicleModal(true);
            setCurrentTripPlannerId(tripPlanner.tripPlannerId);
          }}
          className={classes.yellowBoxText}
        >
          {rolesAndFeatures.assignText}
        </span>
      </>
    );
  } 
  else if (rolesAndFeatures.isCustomer && checkRolesForCustomer) { 
    return (
      <>
        Scheduled{" "}
        <span
          onClick={(e: any) => {
            e.stopPropagation();
            setCurrentTransferId(transfer.transferId);
            setCurrentBookingId(transfer.bookingId);
            setShowVehicleModal(vechiclecount > 0 ? true:false);
            setCurrentTripPlannerId(tripPlanner.tripPlannerId);
          }}
          className={classes.yellowBoxText}
        >
          {rolesAndFeatures.assignText}
        </span>
      </>
    );
  } 
  else if (rolesAndFeatures.isSMAUser && checkRolesForSma) { 
    return (
      <>
        Scheduled{" "}
        <span
          onClick={(e: any) => {
            e.stopPropagation();
            setCurrentTransferId(transfer.transferId);
            setCurrentBookingId(transfer.bookingId);
            setShowVehicleModal(true);
            setCurrentTripPlannerId(tripPlanner.tripPlannerId);
          }}
          className={classes.yellowBoxText}
        >
          {rolesAndFeatures.assignText}
        </span>
      </>
    );
  } 
  else if (rolesAndFeatures.isSMADriver && rolesAndFeatures.isVehicleAllocated) {
    return (
      <>
        Scheduled{" "}
        <span
          onClick={(e: any) => {
            e.stopPropagation();
            assignToMeClick(transfer.bookingId, transfer.transferId);
          }}
          className={classes.yellowBoxText}
        >
          {rolesAndFeatures.assignText}
        </span>
      </>
    );
  } else {
    return <>Scheduled</>;
  }
};

// const Status = ({ rolesAndFeatures, setCurrentTransferId, setCurrentBookingId, setShowVehicleModal, assignToMeClick, transfer }: any) => {
//   const classes = useStyles();

//   if (rolesAndFeatures.isAdmin) {
//     if (transfer.assignedVehicle) {
//       return <>Assigned to {transfer.assignedVehicle}</>;
//     } else {
//       return (
//         <>
//           Scheduled{" "}
//           <span
//             onClick={(e: any) => {
//               e.stopPropagation();
//               setCurrentTransferId(transfer.transferId);
//               setCurrentBookingId(transfer.bookingId);
//               setShowVehicleModal(true);
//             }}
//             className={classes.yellowBoxText}
//           >
//             {rolesAndFeatures.assignText}
//           </span>
//         </>
//       );
//     }
//   } else if (rolesAndFeatures.isSMADriver && rolesAndFeatures.isVehicleAllocated) {
//     if (transfer.assignedToMe) {
//       return <>Assigned To Me</>;
//     } else {
//       if (transfer.assignedVehicle) {
//         return <>Assigned to {transfer.assignedVehicle}</>;
//       } else {
//         return (
//           <>
//             Scheduled{" "}
//             <span
//               onClick={(e: any) => {
//                 e.stopPropagation();
//                 assignToMeClick(transfer.bookingId, transfer.transferId);
//               }}
//               className={classes.yellowBoxText}
//             >
//               {rolesAndFeatures.assignText}
//             </span>
//           </>
//         );
//       }
//     }
//   } else {
//     if (transfer.assignedVehicle) {
//       return <>Assigned to {transfer.assignedVehicle}</>;
//     } else {
//       return <>Scheduled</>;
//     }
//   }
// };

const TransferTable = ({
  transfers,
  updatedTransfers,
  checks,
  updateChecks,
  rolesAndFeatures,
  setCurrentTransferId,
  setCurrentBookingId,
  setShowVehicleModal,
  assignToMeClick,
  transferMode,
  userper,
  userperlist,
  setConflictDialogData,
  tripPlanner,
  setCurrentTripPlannerId,
  vechiclecount
}: any) => {
  const classes = useStyles();
  const history = useHistory();
  const [onCancel, setonCancel] = useState<any>(false);

  const transferdetails = (bookingId: any, transferid: any) => {
    if (userperlist !== null) {
      const userper = checkuserpermissiontransfer(userperlist);
      if (userper !== null) {
        setConflictDialogData(userper);
        return null;
      }
    }
    else {
      history.push(`/transferDetails/${bookingId}/${transferid}`)
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.table}>
        <div className={tripPlanner.servicedBy==ServicedBy.SMA ? classes.tableHead : classes.cusTableHead}>
          <div className={classes.multiLoadColumn}></div>
          <div className={classes.pickupTimeColumn}>Pickup time</div>
          <div className={classes.patientColumn}>Patient</div>
          <div className={classes.needsColumn}>Needs</div>
          <div className={classes.fromColumn}>From</div>
          <div className={classes.toColumn}>To</div>
          <div className={classes.priorityColumn}>Pri</div>
          <div className={classes.statusColumn}>Status</div>
          <div className={classes.actionButtonColumn}></div>
        </div>
        {userper === null ?
          transfers.map((row: any, index: number) => {
            if (transferMode == 1 && !row.assignedToMe && rolesAndFeatures.isSMADriver) return null;
            if (transferMode == 1 && row.assignedVehicle != null && rolesAndFeatures.isAdmin) return null;
            return (
              <div
                className={clsx(tripPlanner.servicedBy==ServicedBy.SMA ? classes.tableRow : classes.cusTableRow, {
                  [classes.animatedUpdatedItem]: updatedTransfers.some(
                    (e: any) => e.TransferId === row.transferId && new Date().getTime() - e.UpdatedDate < 60000
                  ),
                })}
                key={index}
                onClick={(e) => transferdetails(row.bookingId, row.transferId)}
              //onClick={(e) => userperlist === null ?  history.push(`/transferDetails/${row.bookingId}/${row.transferid}`) :null}

              >
                <div className={classes.multiLoadColumn}>
                  {row.firstInMultiLoad && <span className={classes.groupStart} />}
                  {row.middleInMultiLoad && (
                    <span className={classes.groupMiddle}>
                      <span className={classes.groupMidTop} />
                      <span className={classes.groupMidBottom} />
                    </span>
                  )}
                  {row.lastInMultiLoad && <span className={classes.groupEnd} />}
                  {rolesAndFeatures.transferCheckboxes && row.assignedToMe && (
                    <Checkbox
                      checked={checks[index]}
                      onClick={(e: any) => e.stopPropagation()}
                      onChange={() => updateChecks(index)}
                      className={classes.checkboxes}
                    />
                  )}
                </div>
                <div className={classes.pickupTimeColumn}>{getTimeFromDate(row.scheduledDate)}</div>
                <div className={classes.patientColumn}>
                  {row.firstName[0]} {row.lastName}
                </div>
                <div className={classes.needsColumn}>
                  {row.bookingSpecialNeeds.map((item: any) => (
                    <NeedIcon
                      key={row.bookingId + item.specialNeedId}
                      iconName={item.specialNeedIconUrl.split("/")[item.specialNeedIconUrl.split("/").length - 1]}
                    />
                  ))}
                  {row.mobility === 1 && <NeedListItem key="notambulant" text={"Not Ambulant"} iconUrl={"../../assets/svgs/nonambulant.svg"} />}
                  {row.mobility !== 1 && <NeedListItem key="ambulant" text={"Ambulant"} iconUrl={"../../assets/svgs/ambulant.svg"} />}
                  {row.classification && <AcuityNeedItem key="acuity" text={row.classification} />}
                </div>
                <div className={classes.fromColumn}>{getOriginLocationString(row, true)}</div>
                <div className={classes.toColumn}>
                  <span style={{ float: "left" }}>
                    <CompassIcon angle={row.bearingAngle || 0} theme={"dark"} />
                  </span>
                  {getDestinationLocationString(row, true)}
                </div>

                <div className={classes.priorityColumn}>
                  <PriorityBadge priority={row.priority} />
                </div>
                <div className={classes.statusColumn}>
                  <Status
                    rolesAndFeatures={rolesAndFeatures}
                    transfer={row}
                    setCurrentTransferId={setCurrentTransferId}
                    setCurrentBookingId={setCurrentBookingId}
                    setShowVehicleModal={setShowVehicleModal}
                    assignToMeClick={assignToMeClick}
                    setCurrentTripPlannerId={setCurrentTripPlannerId}
                    tripPlanner={tripPlanner}
                    vechiclecount={vechiclecount}
                  />
                </div>

                <div className={classes.actionButtonColumn}>
                  <IconButton aria-label="expand row" size="small">
                    <ArrowForwardIosIcon style={{ fontSize: 20 }} />
                  </IconButton>
                </div>
              </div>
            );
          })
          : transfers.length > 0 ? <div className={classes.noTransfersText}>You do not have access to view the patient list</div> :
            null
        }
        {transfers.length === 0 && tripPlanner.servicedBy==ServicedBy.SMA && <div className={classes.noTransfersText}>No Records Found</div>}
        {transfers.length === 0 && tripPlanner.servicedBy==ServicedBy.Customer && <div className={classes.cusNoTransfersText}>No Records Found</div>}
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  root: {},
  table: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    // maxHeight: "280px",
    overflowY: "auto",
  },
  tableHead: {
    height: 43,
    minHeight: 43,
    maxHeight: 43,
    backgroundColor: "#012756",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "22px",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    borderTop: "1px solid #00152E",

    "& > div": {
      color: "rgba(255, 255, 255, 0.3)",
    },
  },
  cusTableHead: {
    height: 43,
    minHeight: 43,
    maxHeight: 43,
    backgroundColor: "#41276A",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "22px",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    borderTop: "1px solid #00152E",

    "& > div": {
      color: "rgba(255, 255, 255, 0.3)",
    },
  },
  tableRow: {
    display: "flex",
    alignItems: "center",
    color: "#FFFFFF",
    fontWeight: 500,
    backgroundColor: "rgb(2, 72, 157, 0.23)",
    height: 45,
    minHeight: 45,
    maxHeight: 45,
    fontSize: "18px",
    lineHeight: "22px",
    borderTop: "1px solid #00152E",
    cursor: "pointer",

    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },

    "&:not(:last-child)": {
      borderBottom: "1px solid #00152E",
    },
  },
  cusTableRow: {
    display: "flex",
    alignItems: "center",
    color: "#FFFFFF",
    fontWeight: 500,
    backgroundColor: "#222050",
    height: 45,
    minHeight: 45,
    maxHeight: 45,
    fontSize: "18px",
    lineHeight: "22px",
    borderTop: "1px solid #00152E",
    cursor: "pointer",

    "&:hover": {
      backgroundColor: "#2d2b5c",
    },

    "&:not(:last-child)": {
      borderBottom: "1px solid #00152E",
    },
  },
  tableCell: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    height: 33,
  },
  animatedUpdatedItem: {
    animation: `$updatedTransferEffect 60000ms ease-out`,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08) !important",
    },
  },
  "@keyframes updatedTransferEffect": {
    "0%": { backgroundColor: "#F4B8273A" },
    "100%": { backgroundColor: "#002047" },
  },
  multiLoadColumn: {
    flex: "0 0 53px",
    display: "flex",
    justifyContent: "center",
    height: "100%",
  },
  patientColumn: {
    paddingLeft: 10,
    flex: "1 1 169px",
    display: "flex",

    "& span": {
      color: "#010B18",
      opacity: "0.39",
    },

    "@media (max-width: 1280px)": {
      display: "none",
    },
  },
  pickupTimeColumn: {
    paddingLeft: 15,
    flex: "0 0 171px",
  },
  needsColumn: {
    paddingLeft: 15,
    flex: "0 0 164px",
    display: "flex",
    alignItems: "center",

    "& img": {
      width: 18,
      height: 18,
    },
    "@media (max-width: 1280px)": {
      display: "none",
    },
  },
  fromColumn: {
    paddingLeft: 15,
    flex: "1 1 248px",
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  toColumn: {
    paddingLeft: 15,
    flex: "1 1 248px",
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  priorityColumn: {
    flex: "0 0 47px",
  },
  statusColumn: {
    flex: "1 1 245px",
  },
  actionButtonColumn: {
    paddingLeft: 15,
    paddingRight: 10,
    flex: "0 0 32px",
    display: "flex",
    justifyContent: "flex-end",
  },
  noTransfersText: {
    display: "flex",
    justifyContent: "center",
    fontWeight: 500,
    backgroundColor: "rgb(2, 72, 157, 0.23)",
    height: 55,
    fontSize: "18px",
    lineHeight: "22px",
    alignItems: "center",
  },
  cusNoTransfersText: {
    display: "flex",
    justifyContent: "center",
    fontWeight: 500,
    backgroundColor: "#222050",
    height: 55,
    fontSize: "18px",
    lineHeight: "22px",
    alignItems: "center",
  },
  checkboxes: {
    padding: 0,
    margin: 0,
  },
  yellowBoxText: {
    background: "#F4B827",
    padding: "6px 16px",
    fontSize: 14,
    fontWeight: 700,
    color: "#03090E",
    borderRadius: 4,
    marginLeft: 5,
    cursor: "pointer",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  groupStart: {
    backgroundColor: "transparent",
    width: "10px",
    height: "20px",
    borderTop: "2px solid #fff",
    borderLeft: "2px solid #fff",
    alignSelf: "flex-end",
  },
  groupMiddle: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  groupMidTop: {
    backgroundColor: "transparent",
    width: "10px",
    height: "21px",
    borderLeft: "2px solid #fff",
  },
  groupMidBottom: {
    backgroundColor: "transparent",
    width: "10px",
    height: "21px",
    borderTop: "2px solid #fff",
    borderLeft: "2px solid #fff",
  },
  groupEnd: {
    backgroundColor: "transparent",
    width: "10px",
    height: "20px",
    borderBottom: "2px solid #fff",
    borderLeft: "2px solid #fff",
    alignSelf: "flex-start",
  },
});

export default TransferTable;
